import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import About from '../About/About';
import { client } from '../utils/contentful.js';
import { generateKey, removeSpacing, fixBackground, unFixBackground } from '../utils/utils.js';
import { MobilePosts } from '../Styles'
import NavLinks from './NavLinks'
class Navigation extends Component {
	state = {
		infoState: 'info',
		mobileNav: 'none',
		newFont: ''
	};

	componentDidMount() {
		client
			.getEntries({
				content_type: 'navigation'
			})
			.then((res) => {
				if (!res.items || !res.items[0]) return;
				const navigation = res.items;
				const navFont = res.items[0].fields.navFont;
				const newFont = navFont && navFont.fields && navFont.fields.file
					? navFont.fields.file.url
					: '';
				this.setState({ navigation, newFont });
			})
			.catch((err) => {
				console.error('Navigation fetch failed', err);
			});
	}

	openInfo = (event) => {
		event.preventDefault();
		fixBackground()
		let pageScrollTop = window.scrollY;
		this.setState({ topPos: pageScrollTop, infoState: 'info__open' });
	};

	closeInfo = () => {
		this.setState({ infoState: 'info__hidden' });
		unFixBackground()
		window.scrollTo(0, this.state.topPos);
	};

	openNav = (e) => {
		e.preventDefault();
		let pageScrollTop = window.scrollY;

		if (this.state.mobileNav === 'none') {
			fixBackground();
			this.setState({ topPos: pageScrollTop, mobileNav: 'block' });
		} else {
			this.setState({ mobileNav: 'none' });
			unFixBackground()
			window.scrollTo(0, this.state.topPos);
		}
	};

	render() {
		let about, home, elsewhere, sister;
		if (this.state.navigation) {
			this.state.navigation[0].fields.navigationElements.map((item) => {
				item.sys.contentType.sys.id === 'info' ? (about = item.fields.title) : (about = 'about');
				item.sys.contentType.sys.id === 'homepage' ? (home = item.fields.titles) : (home = 'here');
				item.sys.contentType.sys.id === 'elsewhere' ? (elsewhere = item.fields.title) : (elsewhere = 'there');

				if (item.fields.title !== undefined && item.fields.title.toLowerCase() === 'sister') {
					sister = item.fields;
				}
				return { about, home, elsewhere, sister };
			});
		}

		let postTitles = this.props.allContent.map((post, index) => {
			return (
				<Link to={`/project/` + removeSpacing(post.fields.title)} key={generateKey(index)}>
					{post.fields.title}
				</Link>
			);
		});

		let fontStyles = {
			fontFamily: this.state.newFont !== '' ? 'newFont' : '',
			fontSize: '14px',
			fontSizeAdjust: 1
		};
		let fontStylesh1 = {
			fontFamily: this.state.newFont !== '' ? 'newFont' : '',
			fontSize: '14px',
			fontSizeAdjust: 1,
			minHeight: '16px'
		};

		return (
			<header>
				<style
					dangerouslySetInnerHTML={{
						__html:
							`
							@font-face {
								font-family: 'newFont';
								src: url(${this.state.newFont});
							}
						`
					}}
				/>
				<h1 style={fontStylesh1}>
					<Link onClick={() => this.props.setFilter('')} to="/">Claire Arnold</Link>
				</h1>
				<NavLinks
					fontStyles={fontStyles}
					navItems={this.state.navigation}
					openInfo={this.openInfo}
					setFilter={this.props.setFilter}
					location={this.props.location}
				/>
				<About display={this.state.infoState} closeInfo={this.closeInfo} />
				<MobilePosts
					className={`mobile all-text display-${this.state.mobileNav}`}
					style={{ display: this.state.mobileNav }}
				>
					<div className="close-all" onClick={(e) => this.openNav(e)}>
						close
					</div>
					{postTitles}
				</MobilePosts>
			</header>
		);
	}
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/Nav/Nav.js